export default __webpack_public_path__ + "static/media/hardtoys.00d241b0.png";